// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MePaymentService } from '../me-payment.service';

@Component({
    selector: 'me-payment-form',
    templateUrl: './payment-form.component.html',
    styleUrls: ['./payment-form.component.scss']
})

export class MePaymentFormComponent implements OnInit {
    form: FormGroup;
    submitted = false;
    checked = false;
    errorMessage = '';
    dateFormat: string = 'DD.MM.YYYY';
    contactId = 0;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public paymentService : MePaymentService,
        public router: Router
    ) {

    }

    ngOnInit() {
        this.form = this.fb.group({
            first_name: ['', [Validators.required]],
            last_name: ['', [Validators.required]],
            street: ['', [Validators.required]],
            postal_code: ['', [Validators.required]],
            city: ['', [Validators.required]],
            save_billing_information: [false, [Validators.required]]
        });

        this.getBillingData();
    }

    getBillingData() {
        this.appService.isLoading = true;
        this.paymentService.getBillingAddress().subscribe(res => {
            if(res['data'] && res['data']['id']) {
                this.form.patchValue(res['data']);
                this.contactId = res['data']['id'];
            }
            this.appService.isLoading = false;
        });
    }

    submit(data, isValid) {
        this.submitted = true;
        if (!isValid || !this.checked) {
            return;
        }

        this.appService.isLoading = true;
        data['article_type'] = this.paymentService.articleType;
        data['coupon_code'] = this.paymentService.couponCode;
        this.paymentService.createPayment(data).subscribe(res => {
            this.appService.isLoading = false;
            if (res['checkout_link']) {
                window.location.href = res['checkout_link'];
            } else {
                this.router.navigate(['me/dashboard']);
            }
        });
    }
}
